import {
  routeForHome,
  routeForSurveys,
} from '@watershed/shared-universal/dashboardRoutes';

import { useIsSupplierOrg } from '../../../utils/UserContext';

let lastAppRoute: string | null = null;

/**
 * This adorable little hook allows us to take note of the last route the user was on prior to navigating to the settings page.
 * This allows us to navigate back to that route after the user has finished configuring their settings.
 */
export default function useBackToAppFromSettings() {
  const isSupplierOrg = useIsSupplierOrg();
  function setLastAppRoute(route: string) {
    console.info('[useBackToAppFromSettings] setting last app route: ', route);
    lastAppRoute = route;
  }

  function getBackToAppPath(): string {
    if (!lastAppRoute) {
      console.info(
        '[useBackToAppFromSettings] no last app route found; returning home route'
      );
      return isSupplierOrg ? routeForSurveys() : routeForHome();
    }
    console.info(
      '[useBackToAppFromSettings] returning last app route: ',
      lastAppRoute
    );
    return lastAppRoute;
  }

  return {
    setLastAppRoute,
    getBackToAppPath,
  };
}
